import { getStoredUser, type PermissionLevel } from "./auth-storage.ts"

/**
 * ΤΟ FRONTEND ΔΕΝ ΕΙΝΑΙ ΦΡΑΓΜΑ.
 *
 * Κρύβει μενού και κουμπιά ώστε η οθόνη να δείχνει μόνο ό,τι δουλεύει — το
 * φράγμα είναι το middleware του server, που απαντά 403 σε όποιον χτυπήσει το
 * URL απευθείας. Ένα κουμπί που κρύβεται εδώ και δεν ελέγχεται εκεί δεν είναι
 * ασφάλεια, είναι διακόσμηση.
 */
export function can(resource: string, level: "read" | "full" = "read"): boolean {
  const map = getStoredUser()?.permissions
  const current: PermissionLevel = (map?.[resource] as PermissionLevel) ?? "none"

  return level === "read" ? current === "read" || current === "full" : current === "full"
}

/** Οι ελληνικές ετικέτες των ενοτήτων — παρουσίαση, οπότε ζουν εδώ και όχι στον server. */
export const RESOURCE_LABELS: Record<string, string> = {
  dashboard: "Αρχική",
  inventory: "Αποθήκη",
  orders: "Παραγγελίες",
  history: "Ιστορικό",
  customers: "Πελάτες",
  settings: "Ρυθμίσεις",
  staff: "Προσωπικό",
  scan: "Σάρωση",
  production: "Παραγωγή",
  purge: "Οριστική διαγραφή",
}

export const ROLE_LABELS: Record<string, string> = {
  admin: "Admin",
  warehouse: "Αποθηκάριος",
  sales: "Πωλητής",
  worker: "Εργάτης",
}

/**
 * Πού προσγειώνεται ο χρήστης.
 *
 * Με τη σειρά του μενού, ώστε ο καθένας να βρίσκει πρώτο ό,τι κάνει
 * περισσότερο: ο εργάτης στη Σάρωση, ο πωλητής στις Παραγγελίες.
 */
export function firstAllowedPath(): string {
  const order: [string, string][] = [
    ["dashboard", "/"],
    ["inventory", "/inventory/security-doors"],
    ["orders", "/orders/security-doors"],
    ["history", "/orders/history"],
    ["customers", "/customers"],
    ["scan", "/scan"],
    ["production", "/production"],
    ["settings", "/settings"],
    ["staff", "/settings/staff"],
  ]

  for (const [resource, path] of order) {
    if (can(resource)) return path
  }

  return "/no-access"
}
